export default class Attribute
{
  constructor(date, tasks, places, people, notes) 
  {
    this.date = date;
    this.tasks = tasks;
    this.places = places;
    this.people = people;
    this.notes = notes;
  }    

  isValid()
  {
    return this.date && this.tasks.length && this.places.length && this.people.length;
  }
}